import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Carousel from "react-bootstrap/Carousel";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { isMobileOrTablet } from "../Utils";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index";
import "./index.css";


export default function HeaderNav({bannerData}) {
    const imgCDNURL = process.env.REACT_APP_CDN_URL;
  const [navbar, setNavbar] = useState(false);
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);
  const [rigVedQuotes, setRigVedQuotes] = useState([]);
  const [navbarExpanded, setNavbarExpanded] = useState(false);

  const isMobileOrTabletDevice = isMobileOrTablet();
  
  let prevScrollPos = window.scrollY;

  window.onscroll = function () {
    const currentScrollPos = window.scrollY;
    const menuNavbar = document.getElementById("menuNavbar");
    if (currentScrollPos === 0) {
      menuNavbar.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        // Perform your desired actions for scrolling up here
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        // Perform your desired actions for scrolling down here
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar.classList.add("navbarTransition");
          setShowRigVedQuotes(false);
        }
      }
    }
    setNavbarExpanded(false);
    prevScrollPos = currentScrollPos;
  };

  const handleMenuClick = () => {
    if (isMobileOrTabletDevice) {
      setNavbarExpanded(false);
    }
  };

  useEffect(() => {
    const fetchRigVedQuotes = async () => {
      try {
        await axios
          .get(`${process.env.REACT_APP_RIGVED_QUOTES_JSON}?timestamp=${Date.now()}`)
          .then(async (response) => {
            const responseData = response.data;
            setRigVedQuotes(responseData.quotes);
          })
          .catch((error) => {
            console.log("Unable to load rigveda quotes: ", error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchRigVedQuotes();
  }, []);

  const handleToggle = () => {
    // Check if the navbar is currently expanded
    if (navbarExpanded) {
      // If it is expanded, close it
      setNavbarExpanded(false);
    } else {
      // Otherwise, toggle it
      setNavbarExpanded(true);
    }
    // Close the RigVedQuotes whenever the navbar is toggled
    setShowRigVedQuotes(false);
  };

  // Function to handle RigVedQuote click
  const handleRigVedQuoteClick = () => {
    // Close the navbar and show RigVedQuotes if needed
    setNavbarExpanded(false);
    setShowRigVedQuotes(true);
  };

  const handleMouseEnter = () => {
    setShowRigVedQuotes(true);
  };

  const handleMouseLeave = () => {
    setShowRigVedQuotes(false);
  };

  const handleCloseIconClick = () => {
    setShowRigVedQuotes(false);
  };
 

  return (
    <>
      <div id="homeheader">
        <Navbar
          id="menuNavbar"
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          expanded={navbarExpanded}
          className={navbar ? "navbar active" : "navbar"}
        >
          <Container>
          <Navbar.Brand className="ps-3">
              <div className="d-flex">
                <div>
                  <a
                    href="https://www.swmc.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Sun West Mortgage Logo"
                  >
                    <img
                      src={
                        "https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-White.svg"
                      }
                      className="main_logo_hme "
                      alt="Sun West Logo"
                    />
                  </a>
                </div>
                <div className="deskaccesibilty">
                <UserWayAccessibilityMenu
                  color="white"
                  width={40}
                  height={40}
                />
                </div>
              </div>
            </Navbar.Brand>
           

            <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={handleToggle} />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav>
              <a
                 href={"tel:" + bannerData.phone.phoneWithIntCode}
               
                  onClick={handleMenuClick}
                >
              <div className="completeyoutubediv">
              
                 <div className="youtext d-flex"><img src={imgCDNURL + "phone.webp"} className="youtubeicon " alt="Contact Us"></img><p className="ps-2 mb-0">Contact Us </p></div>
              
                </div>
                </a>
                <div className="borderdivline"></div>
                <a
                 href={bannerData.email.emailUrl}
               
                  onClick={handleMenuClick}
                >
                <div className="completeyoutubedivemail">
              
                 <div className="youtext d-flex"><img src={imgCDNURL + "mail.webp"} className="youtubeicon " alt="Contact Us"></img><p className="ps-2 mb-0">inquiry@swmc.com</p></div>
                
                </div>
                </a>
                <UserWayAccessibilityMenu
                  color="white"
                  width={40}
                  height={40}
                />
              </Nav>
            </Navbar.Collapse>
          </Container>
       
        </Navbar>
      </div>
     
    </>
  );
}